import(/* webpackMode: "eager" */ "/usr/src/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/lib/Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/lib/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../public/font/vazir/Vazir-Medium.woff\",\"variable\":\"--font-vazir\",\"weight\":\"100 900\"}],\"variableName\":\"vazir\"}");
